//Imports
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

//Controls
import { Button, Form, Modal, Select } from "@gpstrackit/gtc-react-controls";

//Components
import { NotificationManager, NotificationContainer } from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";

//Actions
import { manageDeleteManageLocations, reset } from "./redux/slice";
import { useDispatch, useSelector } from "react-redux";
import { manageSearchAllLocations, manageSearchLocations } from "../../redux/slice";

const DeleteManageLocation = ({ refresh }) => {
  //States
  const [formData, setFormData] = useState({ receiver: 0 });
  //Redux
  const dispatch = useDispatch();
  const {
    open,
    loading,
    result,
    error: errorDeleteLocations,
    deleteLocations
  } = useSelector((state) => state.manageDeleteManageLocationsRedux);
  const {
    loadingAllLocations,
    allLocations,
    error: errorLoadingLocations
  } = useSelector((state) => state.manageLocationsTabRedux);
  const error = useMemo(
    () => errorDeleteLocations || errorLoadingLocations,
    [errorDeleteLocations, errorLoadingLocations]
  );

  // Has units should be true if the location has units
  const hasUnits = deleteLocations?.some((location) => location.unitsCount > 0)
  const getIds = deleteLocations?.map((location) => location.id)
  const filteredLocations = allLocations.filter((location) => !getIds.includes(location.id))

  //Form refs
  const deleteLocationsForm = useRef(null);

  //Language
  const { messages } = useIntl();

  //Handlers and utils
  const handleClose = useCallback(() => dispatch(reset()), []);

  const handleDeleteSubmit = useCallback(() => {
    const ids = deleteLocations?.length
      ? deleteLocations.map((driverStatus) => driverStatus.id)
      : [deleteLocation?.id];
    const { receiver } = formData;
    const data = {
      ids,
      moveChildsToLocationId: receiver.id
    };
    dispatch(manageDeleteManageLocations(data));
  }, [deleteLocations, formData]);

  //Effects
  useEffect(() => {
    dispatch(manageSearchAllLocations({}));
  }, []);

  useEffect(() => {
    if (!error) return;
    NotificationManager.error(
      error?.error || messages["errorMessage"],
      messages["error"],
      3000,
      null,
      null,
      "error"
    );
    dispatch(reset({ error: null }));
  }, [error]);

  useEffect(() => {
    if (!result) return;
    const messageSuccess = deleteLocations?.length > 1
      ? messages["manage_deletedLocations"]
      : messages["manage_deletedLocation"];
    NotificationManager.success(messageSuccess, messages["success"], 3000, null, null, "success");
    refresh();
    dispatch(reset());
  }, [result]);


  return (
    <Modal
      title={
        deleteLocations?.length > 1 ? messages["manage_deleteLocations"] : messages["manage_deleteLocation"]
      }
      size="small"
      open={open}
      handleClose={handleClose}
      loading={loading}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            isDisabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button variant="warning" onClick={() => handleDeleteSubmit()} isDisabled={loading}>
            {messages["delete"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "10px 25px" }}>
        <p>{messages["manage_deleteManageLocation_confirmationMessage"]}</p>
        <ul>
          {
            deleteLocations.map((driverStatus, index) => <li key={index}>{driverStatus.title}</li>)
          }
        </ul>
        {hasUnits && (
          <Form ref={deleteLocationsForm} onValidSubmit={() => handleDeleteSubmit()}>
            <p>{messages["manage_deleteManageLocation_transferUnits"]}</p>
            <Form.Item name="receiver">
              <Select
                style={{ width: '100%' }}
                label={messages["manage_deleteManageLocation_toReceive"]}
                id={"receiver"}
                loading={loadingAllLocations}
                options={filteredLocations}
                textField="title"
                valueField="id"
                placeholder={messages["manage_deleteManageLocation_selectLocation"]}
                isSearchable={true}
                value={formData.receiver}
                onChange={(value) => {
                  setFormData((currentFormData) => ({ ...currentFormData, receiver: value }));
                }}
                isClearable={true}
                requiredMessage={messages["required_field"]}
              />
            </Form.Item>
          </Form>
        )}
      </div>
      <NotificationContainer />
    </Modal>
  );
};

export default DeleteManageLocation;
